const stats = [
  { value: 15, suffix: "+", label: "Clients Served" },
  { value: 11, suffix: "+", label: "Years in Industry" },
  { value: 97, suffix: "%", label: "Satisfied Clients" },
  { value: 25, suffix: "+", label: "Projects Deployed" },
];

export default stats;